<template>
  <div class="container-fluid">

    <div v-if="oscarPoolSettings" class="back-button">
      <router-link :to="`/oscar-pool/${club_id}`">
        <i class="fa fa-angle-double-left" aria-hidden="true"></i> Return to Oscar Pool
      </router-link>
    </div>

    <div v-if="oscarPoolSettings" class="card mol-center-card-width setup-card">
      <div class="card-header">
        <h2><ClubPicture :club="club" size="35"></ClubPicture> {{ club.name }}</h2>
        <h1>SCORING SETUP</h1>
        <div class="ceremony-number-and-year">{{ ceremonyOrdinalText }} Ceremony • {{ ceremonyDateText }}</div>
        <div>Honoring achievements in</div>
        <div>{{ filmInfo.length }} films from {{ ceremonyYearsHonoredText }}</div>

        <div v-if="oscarPoolSettings.active" class="oscar-pool-active-message">
          OSCAR POOL ACTIVE <br> No Further Changes Allowed
        </div>

      </div>

      <div class="card-body">

        <table class="points-table">

          <thead>
            <tr style="border-bottom: 1px solid black;">
              <th>categories</th>
              <th>points</th>
              <th v-if="!oscarPoolSettings.active || oscarPoolSettings.second_choice_enabled">
                <input v-if="!oscarPoolSettings.active" type="checkbox" v-model="oscarPoolSettings.second_choice_enabled"> <span :class="{'disabled-second-choice-header': !oscarPoolSettings.second_choice_enabled}">2nd<br>choice</span>
              </th>
            </tr>
          </thead>

          <tbody>
            <tr v-for="category_points in oscarPoolSettings.category_points" :key="category_points.name">
              <td v-html="category_points.name"></td>

              <td>
                <span v-if="oscarPoolSettings.active">{{category_points.points}}</span>
                <input v-else type="number" min="0" max="1000" step="1" v-model.number="category_points.points" @change="clampPointValues">
              </td>

              <td v-if="!oscarPoolSettings.active || oscarPoolSettings.second_choice_enabled">
                <span v-if="oscarPoolSettings.active && oscarPoolSettings.second_choice_enabled">{{category_points.points_second_choice}}</span>
                <input v-else type="number" min="0" max="1000" step="1" v-model.number="category_points.points_second_choice" @change="clampPointValues" :disabled="!oscarPoolSettings.second_choice_enabled">
              </td>
            </tr>
          </tbody>

        </table>


        <div v-if="!oscarPoolSettings.active" class="text-center">
          <button type="submit" class="btn btn-outline-mol" :class="{disabled: updatingOscarPool}" @click.prevent="saveOscarPoolSettings(false)">
            <span v-if="updatingOscarPool" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"> </span>
            <i class="fa fa-floppy-o"></i> save settings
          </button>

          <button type="submit" class="btn btn-mol" :class="{disabled: savingPool}" @click.prevent="saveOscarPoolSettings(true)">
            <span v-if="updatingOscarPool" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"> </span>
            <i class="fa fa-rocket"></i> launch oscar pool
          </button>
        </div>

      </div>
    </div>


<!--    <div v-if="oscarPoolSettings">-->
<!--      <div v-for="category_points in oscarPoolSettings.category_points" :key="category_points.normalized_name">-->
<!--        {{category_points.name}} | {{category_points.points}} | {{category_points.points_second_choice}}-->
<!--      </div>-->
<!--    </div>-->

    <div v-if="oscarPoolSettings" class="back-button">
      <router-link :to="`/oscar-pool/${club_id}`">
        <i class="fa fa-angle-double-left" aria-hidden="true"></i> Return to Oscar Pool
      </router-link>
    </div>

  </div>
</template>


<script>

import axios from "axios";
import {Film} from "@/film";
import analytics from "@/analytics";
import ClubPicture from "@/components/clubs/ClubPicture.vue";
//import ClubPicture from "@/components/clubs/ClubPicture.vue";

const dateFormatObj = new Intl.DateTimeFormat('en-US', {
  timeZone: 'UTC',
  month: 'short',
  day: 'numeric',
  year: 'numeric'
});

export default {
  name: "OscarPoolSetupPage",
  props: ['club_id', 'ceremony'],
  components: { ClubPicture },
  data() {
    return {
      club: null,
      ceremonyInfo: null,
      filmInfo: null,
      oscarPoolSettings: null,
      updatingOscarPool: false
    }
  },
  computed: {
    ceremonyOrdinalText() {
      return Film.getCeremonyOrdinalText(this.oscarPoolSettings.ceremony);
    },
    ceremonyDateText() {
      return dateFormatObj.format(Film.getDateOfCeremony(this.oscarPoolSettings.ceremony));
    },
    ceremonyYearsHonoredText() {
      return Film.ceremonyYearsHonoredText(this.oscarPoolSettings.ceremony);
    },
  },
  created() {
    this.getOscarPoolSettings();
  },

  methods: {
    async getOscarPoolSettings() {
      return axios.get(`/api/club/${this.club_id}/oscar-pool/settings`)
          .then(response => {
            //console.log('GET oscar-pool/settings', response.data);

            this.club = response.data.club_info.club;
            this.ceremonyInfo = response.data.ceremony_info;
            this.filmInfo = response.data.film_info;
            this.oscarPoolSettings = response.data.oscar_pool_settings;
          })
          .catch(err => {
            //console.log('err', err);

            // unauthorized? kick the user back to the club profile page
            if ( err.response?.status === 401 ) {
              this.$router.push({name: 'OscarPoolProfilePage', params: {club_id: this.club_id}});
              return;
            }

            analytics.notifyBugsnagOfError(err);
          });
    },

    async saveOscarPoolSettings(_activate=false) {

      this.updatingOscarPool = true;
      this.oscarPoolSettings.active = !!_activate;

      return axios.post(`/api/club/${this.club_id}/oscar-pool/settings`, {
        ...this.oscarPoolSettings,
      })
          .then(response => {
            //console.log('POST oscar-pool/settings', response.data);

            this.ceremonyInfo = response.data.ceremony_info;
            this.filmInfo = response.data.film_info;
            this.oscarPoolSettings = response.data.oscar_pool_settings;
          })
          .catch(err => {
            console.log(err);
          })
          .finally(() => {
            this.updatingOscarPool = false;
          });
    },

    clampPointValues() {
      const clamp = (value => Math.floor(Math.min( Math.max(value, 0), 1000)) );
      this.oscarPoolSettings.category_points.forEach(cat => {
        cat.points = clamp(cat.points);
        cat.points_second_choice = clamp(cat.points_second_choice);
      });
    },

    categoryDisplayNameHtml(_categoryName) {
      return Film.categoryDisplayNameHtml(_categoryName);
    },

    getDefaultPointValue(_normalizedCategoryName) {

      switch ( _normalizedCategoryName?.toUpperCase() ) {
        case "BEST PICTURE":
          return 100;

        case "DIRECTING":
          return 90;

        case "ACTOR IN A LEADING ROLE":
        case "ACTRESS IN A LEADING ROLE":
        case "ACTOR IN A SUPPORTING ROLE":
        case "ACTRESS IN A SUPPORTING ROLE":
          return 90;

        case "CASTING":
        case "WRITING (ORIGINAL SCREENPLAY)":
        case "WRITING (ADAPTED SCREENPLAY)":
          return 80;

        case "CINEMATOGRAPHY":
          return 80;

        case "VISUAL EFFECTS":
          return 80;

        case "PRODUCTION DESIGN":
          return 70;

        case "FILM EDITING":
          return 70;

        case "SOUND":
          return 70;

        case "MUSIC (ORIGINAL SCORE)":
          return 60;

        case "MUSIC (ORIGINAL SONG)":
          return 60;

        case "INTERNATIONAL FEATURE FILM":
          return 50;

        case "MAKEUP AND HAIRSTYLING":
          return 50;

        case "COSTUME DESIGN":
          return 50;

        case "ANIMATED FEATURE FILM":
          return 40;

        case "ANIMATED SHORT FILM":
          return 20;

        case "DOCUMENTARY FEATURE FILM":
          return 40;

        case "DOCUMENTARY SHORT FILM":
          return 20;

        case "LIVE ACTION SHORT FILM":
          return 20;
      }
      return 10;
    }
  }
}
</script>


<style scoped>

.container-fluid {
  padding-top: 20px;
  background-color: var(--mol-color-gold-background);

  .back-button {
    text-align: center;
    padding-bottom: 1.5em;

    a {
      color: var(--mol-color-gold-text);
      text-decoration: inherit;
    }
  }

}

.setup-card {

  background-color: white;
  overflow: hidden;
  margin-bottom: 40px;
  padding: 2em;

  border: solid;
  border-width: 3px;
  border-color: var(--mol-color-gold);
  border-radius: 0.375rem;

  .card-header {
    background-color: inherit;
    text-align: center;
    width: 90%;
    font-size: smaller;
    margin: 1em auto 0 auto;
    padding: 1em 0 2em 0;
    border-style: none;

    .ceremony-number-and-year {
      font-weight: bold;
      font-size: large;
    }

    .oscar-pool-active-message {
      border-style: solid;
      border-radius: 5px;
      border-color: var(--mol-color-gold);
      background-color: var(--mol-color-gold-background);

      margin-top: 2em;
      padding-top: 0.75em;
      padding-bottom: 0.75em;
      color: var(--mol-color-gold);
      font-size: large;
      font-weight: bold;
    }

  }

  .card-body {
    padding-left: 0;
    padding-right: 0;
  }
}

.points-table {
  width: 100%;
  margin-bottom: 50px;

  input[type="checkbox"] {
    accent-color: var(--mol-color-gold);
    /*transform: scale(1.5);*/
  }

  tr {
    border-style: none none solid none;
    border-width: 0.1px;
    border-color: darkgrey;

    &:nth-child(even) {
      background-color: var(--mol-color-gold-background);
    }

    th:not(:first-of-type) {
      text-align: center;
    }

    th, td {
      width: 1%;
      padding: 0.3em;


      input[type="number"] {
        /*margin: 0.375em 0 0.375em 0.375em;*/
        width: 4em;
        text-align: center;
        border-radius: 0.5em;
      }

      &:first-of-type {
        width: revert;
      }
    }
  }

  .disabled-second-choice-header {
    color: lightgray;
  }
}

.spinner-border {
  margin-right: 0.5em;
}

</style>